export default __webpack_public_path__ + "static/media/paulana-lamonier-960.61151484.jpg";